function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}

function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}

export function validateFileNameExtension(fileName, extensionArray) {
    if (!fileName) {
        return false;
    }

    if (extensionArray && extensionArray.length > 0) {
        const upper = fileName.toUpperCase();
        let isValid = false;

        for (let i = 0; i < extensionArray.length && !isValid; ++i) {
            const extension = extensionArray[i];
            if (upper.indexOf(extension) >= 0) {
                isValid = true;
            }
        }

        return isValid;
    }
    return true;
}

export default mergeDeep;



// WEBPACK FOOTER //
// ./src/utils/global.js